
import Dashboard from "./views/Dashboard.js";

import daywisereports from "./views/whatsapp/daywisereports.js";
import wtsapcampaignreports from "./views/whatsapp/campaignreports.js";


import ivrdaywisereports from "./views/ivr/ivrdaywisereports.js";
import rcsdaywisereports from "./views/rcs/rcsdaywisereports.js";
import emaildaywisereports from "./views/email/emaildaywisereports.js";

import detailedreports from "./views/whatsapp/detailedreports.js";
import ivrdetailedreports from "./views/ivr/ivrdetailedreports.js";
import rcsdetailedreports from "./views/rcs/rcsdetailedreports.js";
import emaildetailedreports from "./views/email/emaildetailedreports.js";



import createcampaigns from "./views/whatsapp/createcampaigns.js";
import ivrcreatecampaigns from "./views/ivr/ivrcreatecampaigns.js";
import rcscreatecampaigns from "./views/rcs/rcscreatecampaigns.js";
import emailcreatecampaigns from "./views/email/emailcreatecampaigns.js";
import emailcampaignreports from "./views/email/emailcampaignreports.js";


import campaignlist from "./views/whatsapp/campaignlist.js";
import ivrcampaignlist from "./views/ivr/ivrcampaignlist.js";
import rcscampaignlist from "./views/rcs/rcscampaignlist.js";
import emailcampaignlist from "./views/email/emailcampaignlist.js";

//import bulkmessaging from "./views/whatsapp/bulkmessaging.js";
import ivrbulkmessaging from "./views/ivr/ivrbulkmessaging.js";
import rcsbulkmessaging from "./views/rcs/rcsbulkmessaging.js";
import emailbulkmessaging from "./views/email/emailbulkmessaging.js";

import uploadmedia from "./views/whatsapp/uploadmedia.js";
import ivruploadcallflow from "./views/ivr/ivruploadcallflow.js";
//import rcsuploadmedia from "./views/rcs/rcsuploadmedia.js";
import emailuploadmedia from "./views/email/emailuploadmedia.js";

//import createtemplate from "./views/whatsapp/createtemplate.js";
import ivrcreatecallflow from "./views/ivr/ivrcreatecallflow.js";
//import rcscreatetemplate from "./views/rcs/rcscreatetemplate.js";
import emailcreatetemplate from "./views/email/emailcreatetemplate.js";

import templatelist from "./views/whatsapp/templatelist.js";
import ivrcallflowlist from "./views/ivr/ivrcallflowlist.js";
import rcstemplatelist from "./views/rcs/rcstemplatelist.js";
import emailtemplatelist from "./views/email/emailtemplatelist.js";

import instantWhatsapp from "./views/whatsapp/instantWhatsapp.js";
import managetemplates from "./views/whatsapp/managetemplates.js";

import Whatsappchatlist from "./views/whatsapp/Whatsappchatlist.js";

import instantIvr from "./views/ivr/instantIvr.js";
import instantRcs from "./views/rcs/instantRcs.js";
import instantEmails from "./views/email/instantEmails.js";
import instantSms from "./views/sms/instantSms.js";
import SmsApproval from "./views/sms/SmsApproval.js";
import smscampaignreports from "./views/sms/smscampaignreports.js";
import smsFallBackReport from "./views/sms/smsFallBackReport.js";
import smsdetailedreports from "./views/sms/smsdetailedreports.js";

import Mycampaigns from "./views/sms/Mycampaigns.js";
import Reportssms from "./views/sms/Reportssms.js";
import Roles from "./views/user/Roles";
import MenuList from "./views/user/MenuList";
import CreateMenu from "./views/user/CreateMenu";
import Profile from "./views/pages/Profile.js";
// import BreadCrumb from "./views/components/BreadCrumb.js";
//import Sms from "./views/whatsapp/Sms.js";
//import Whatsapp from "./views/whatsapp/Whatsapp.js";
import whtspFallBackReport from "./views/whatsapp/whtspFallBackReport.js";
import logReports from "./views/whatsapp/logreports.js";
import smslogreports from "./views/sms/smslogreports.js";


import RechargeList from "./views/user/RechargeList.js";

//User URL

import UserList from "./views/user/UserList";
import CreateUser from "./views/user/CreateUser";
import GroupList from "./views/groups/GroupList.js";
import CreateGroup from "./views/groups/CreateGroup";
import CreateRole from "./views/user/CreateRole";
import Pulse from "./views/config/Pulse";
import CreatePulse from "./views/config/CreatePulse";
import Credits from "./views/config/Credits.js";
import CreateCredits from "./views/config/CreateCredits.js";

import Viewtemplates from "./views/whatsapp/viewtemplates.js";














import LiveChat from "./views/liveChat/Chat.js"
import ChatReports from "./views/liveChat/ChatReports.js"


//work flow 
import CreateWorkflow  from "./views/workflow/CreateWorkflow.js"
import UploadWorkFlow  from "./views/workflow/UploadWorkFlow.js"
import BotReports  from "./views/workflow/BotReports.js"



//AI
import TextModel from "./views/ai/text/TextModel.js";
import CreateModel from "./views/ai/text/CreateModel.js";
import TextPredictions from "./views/ai/text/TextPredictions.js";
import TextReports from "./views/ai/text/TextReports.js";

import ImageModel from "./views/ai/image/ImageModel.js";
import ImagePredictions from "./views/ai/image/ImagePredictions.js";
import ImageReports from "./views/ai/image/ImageReports.js";
import CreateImageModel from "./views/ai/image/CreateImageModel.js"

import VideoModel from "./views/ai/video/VideoModel.js";
import VideoPredictions from "./views/ai/video/VideoPredictions.js";
import VideoReports from "./views/ai/video/VideoReports.js";
import CreateVideoModel from "./views/ai/video/CreateVideoModel.js"

//client
import ClientList from "./views/clients/CientList.js"
import CreateClient from "./views/clients/CreateClient.js"

//channel 
import ChannelList from "./views/channel/ChannelList.js"
import CreateChannel from "./views/channel/CreateChannel.js"
import ChannelApproval from "./views/channel/ChannelApproval.js"
import Approvedtemplate from "./views/channel/ApprovedChannels.js"
import Approvedsmstemplate from "./views/sms/ApprovedSMSChannels.js"
import Approvedwhatsapptemplate from "./views/whatsapp/ApprovedWhatsappChannels.js"


import DefaultPage from "./views/defaultPage.js";
import UpdateMenu from "./views/user/UpdateMenu.js";

//Analytics
import CTR from "./views/analytics/CTR.js";
import UsageAnalytics from "./views/analytics/UsageAnalytics.js";
import SentimentAnalytics from "./views/analytics/SentimentAnalytics.js"





var parentmenu =[];
var userObj = localStorage.getItem("menus");
var user = JSON.parse(userObj);
 if (user){
  const sortedItems = [...user];

 if(sortedItems){
  
 
for(let i=0;i<sortedItems.length;i++){
  const menuitem = sortedItems[i];
  var isChild = true;
  if(menuitem.submenu.length==0){
    parentmenu.push({
      path: "/"+sortedItems[i].name,
      name: sortedItems[i].displayname,       
      mini: "UL",
      icon:sortedItems[i].icon,      
      layout: "/admin",
      component:sortedItems[i].name === "dashboard" ? Dashboard: sortedItems[i].name === "liveChat" ? LiveChat : sortedItems[i].name === "chatreports" ? ChatReports :sortedItems[i].name === "clients" ? ClientList : DefaultPage,
});
  }else {

    var submenu =[];
    
  for(let j=0;j<sortedItems[i].submenu.length;j++){
    
    if(sortedItems[i].submenu[j].subsubmenu.length==0){
      submenu.push({
        path: "/"+sortedItems[i].name+"/"+sortedItems[i].submenu[j].name,
        name: sortedItems[i].submenu[j].displayname,       
        mini: "UL",
        icon: sortedItems[i].submenu[j].icon,
        component: sortedItems[i].submenu[j].name === "smsmycampaign" ? Mycampaigns 
                  : sortedItems[i].submenu[j].name === "menulist" ? MenuList 
                  : sortedItems[i].submenu[j].name === "roles" ? Roles 
                  : sortedItems[i].submenu[j].name === "userlist" ? UserList 
                  : sortedItems[i].submenu[j].name === "groups" ? GroupList 
                  : sortedItems[i].submenu[j].name === "pulse" ? Pulse 
                  : sortedItems[i].submenu[j].name === "credits" ? Credits 
                  : sortedItems[i].submenu[j].name === "instantemails" ? instantEmails 
                  : sortedItems[i].submenu[j].name === "instantivr" ? instantIvr 
                  : sortedItems[i].submenu[j].name === "instantwhatsapp" ? instantWhatsapp 
                  : sortedItems[i].submenu[j].name === "managetemplates" ? managetemplates 
                  : sortedItems[i].submenu[j].name === "instantrcs" ? instantRcs
                  : sortedItems[i].submenu[j].name === "instantsms" ? instantSms
                  : sortedItems[i].submenu[j].name === "smsapproval" ? SmsApproval
                  : sortedItems[i].submenu[j].name === "liveChat" ? LiveChat
                  : sortedItems[i].submenu[j].name === "chatreports" ? ChatReports
                  : sortedItems[i].submenu[j].name === "createworkflow" ? CreateWorkflow
                  : sortedItems[i].submenu[j].name === "uploadworkflow" ? UploadWorkFlow
                  : sortedItems[i].submenu[j].name === "botreports" ? BotReports
                  : sortedItems[i].submenu[j].name === "channelList" ? ChannelList
                  : sortedItems[i].submenu[j].name === "approval" ? ChannelApproval
                  : sortedItems[i].submenu[j].name === "approvedtemplate" ? Approvedtemplate
                  : sortedItems[i].submenu[j].name === "aprovedsmstemplates" ? Approvedsmstemplate
                  : sortedItems[i].submenu[j].name === "whatsappaprovedtemp" ? Approvedwhatsapptemplate
                  : sortedItems[i].submenu[j].name === "ctr" ? CTR
                  : sortedItems[i].submenu[j].name === "usageanalytics" ? UsageAnalytics
                  : sortedItems[i].submenu[j].name === "sentimentanalytics" ? SentimentAnalytics
                  : sortedItems[i].submenu[j].name === "chathistory" ? Whatsappchatlist

                  

                  



                  : DefaultPage,
        layout: "/admin"
});
    } else {
      var subsubmenu = [];
      
      for(let k=0;k<sortedItems[i].submenu[j].subsubmenu.length;k++){
        subsubmenu.push({
          path:"/"+sortedItems[i].name+"/"+sortedItems[i].submenu[j].name+"/"+sortedItems[i].submenu[j].subsubmenu[k].name,
          name: sortedItems[i].submenu[j].subsubmenu[k].displayname,       
          mini: "UL",
          icon:sortedItems[i].submenu[j].subsubmenu[k].icon,
          component: sortedItems[i].submenu[j].subsubmenu[k].name === "whatsappdaywisereports" ?  daywisereports
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "whatsappcampaginreports" ?  wtsapcampaignreports
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "campaignreports" ?  smscampaignreports 
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "smsreports" ?  Reportssms 
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "smsdetailedreports" ?  smsdetailedreports 
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "smsFallBackReport" ? smsFallBackReport
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "whtspFallBackReport" ? whtspFallBackReport
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "logreports" ? logReports
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "smslogreports" ? smslogreports
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "whatsappdetailedreport" ?  detailedreports 
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "whatsappcreatecampaign" ? createcampaigns 
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "whatsappcampaignlist" ? campaignlist
                   //   : sortedItems[i].submenu[j].subsubmenu[k].name === "whatsappbulkmessaging" ? bulkmessaging
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "whatsappuploadmedia" ? uploadmedia
                     // : sortedItems[i].submenu[j].subsubmenu[k].name === "whatsappcreatetemplate" ? createtemplate
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "whatsapptemplatelist" ? templatelist
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "ivrdaywisereports" ?  ivrdaywisereports
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "ivrdetailedreports" ?  ivrdetailedreports 
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "ivrcreatecampaign" ? ivrcreatecampaigns 
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "ivrcampaignlist" ? ivrcampaignlist
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "ivrbulkmessaging" ? ivrbulkmessaging
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "ivruploadcallflow" ? ivruploadcallflow
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "ivrcreatecallflow" ? ivrcreatecallflow
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "ivrcallflowlist" ? ivrcallflowlist
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "rcsdaywisereports" ?  rcsdaywisereports
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "rcsdetailedreports" ?  rcsdetailedreports 
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "rcscreatecampaign" ? rcscreatecampaigns 
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "rcscampaignlist" ? rcscampaignlist
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "rcsbulkmessaging" ? rcsbulkmessaging
                    //  : sortedItems[i].submenu[j].subsubmenu[k].name === "rcsuploadmedia" ? rcsuploadmedia
                    //  : sortedItems[i].submenu[j].subsubmenu[k].name === "rcscreatetemplate" ? rcscreatetemplate
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "rcstemplatelist" ? rcstemplatelist
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "emaildaywisereports" ?  emaildaywisereports
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "emaildetailedreports" ?  emaildetailedreports 
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "emailcreatecampaign" ? emailcreatecampaigns 
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "emailcampaignlist" ? emailcampaignlist
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "emailbulkmeassaging" ? emailbulkmessaging
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "emailuploadmedia" ? emailuploadmedia
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "emailcreatetemplate" ? emailcreatetemplate
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "emailtemplatelist" ? emailtemplatelist
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "emailcampaignreports" ?emailcampaignreports
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "textmodels" ? TextModel
                     

                      : sortedItems[i].submenu[j].subsubmenu[k].name === "textpredictions" ? TextPredictions
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "textreports" ? TextReports
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "imagemodels" ? ImageModel
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "imagepredictions" ? ImagePredictions
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "imagereports" ? ImageReports
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "videomodels" ? VideoModel
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "videopredictions" ? VideoPredictions
                      : sortedItems[i].submenu[j].subsubmenu[k].name === "videoreports" ? VideoReports

                      : sortedItems[i].submenu[j].subsubmenu[k].name === "ctr" ? CTR

                      
                      

                      

                      : DefaultPage,
          layout: "/admin"
  });
      }
      submenu.push({
        isChild:"1",
        collapse: isChild,
        name: sortedItems[i].submenu[j].displayname,   
        icon: sortedItems[i].submenu[j].icon,
        state: sortedItems[i].submenu[j].name+"Collapse",
        views: subsubmenu
       });
    }
   
  }
 
  parentmenu.push({
    collapse: isChild,
    name: sortedItems[i].displayname,   
    icon: sortedItems[i].icon,
    state: sortedItems[i].name+"Collapse",
    views: submenu
  });

  }
  
  }
}
 }
 


const routes = [...parentmenu,
    {
    path: "/ai/text/createModel",
    component: CreateModel,
    layout: "/admin",
    name: "",
  },
  {
    path: "/ai/image/createImageModel",
    component: CreateImageModel,
    layout: "/admin",
    name: "",
  },
  {
    path: "/ai/video/createVideoModel",
    component: CreateVideoModel,
    layout: "/admin",
    name: "",
  },
  {
    path: "/user/createUser",
    component: CreateUser,
    layout: "/admin",
    name: "",
  },
  {
    path: "/user/createRole",
    component: CreateRole,
    layout: "/admin",
    name: "",
  },
  {
    path: "/user/createMenu",
    component: CreateMenu,
    layout: "/admin",
    name: "",
  },
  {
    path: "/user/updateMenu",
    component: UpdateMenu,
    layout: "/admin",
    name: "",
  },{
    path: "/client/createclient",
    component: CreateClient,
    layout: "/admin",
    name: "",
  },
  {
    path: "/channel/createchannel",
    component: CreateChannel,
    layout: "/admin",
    name: "",
  },
  {
    path: "/groups/createGroup",
    component: CreateGroup,
    layout: "/admin",
    name: "",
  },
  {
    path: "/config/createPulse",
    component: CreatePulse,
    layout: "/admin",
    name: "",
  },
  {
    path: "/config/createCredits",
    component: CreateCredits,
    layout: "/admin",
    name: "",
  },
  {
    path: "/whatsapp/viewtemplates",
    component: Viewtemplates,
    layout: "/admin",
    name: "",
  },
  
  
  
  

];

export default routes;


